module.exports = __webpack_public_path__ + "officialStatic/img/soft9.0dc1fb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/soft9.png
// module id = 3yg4
// module chunks = 0